import { render, staticRenderFns } from "./GraphTournament.vue?vue&type=template&id=1ac98d76"
import script from "./GraphTournament.vue?vue&type=script&lang=js"
export * from "./GraphTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports